import { render, staticRenderFns } from "./TheContent.vue?vue&type=template&id=15bac40c&"
import script from "./TheContent.vue?vue&type=script&lang=js&"
export * from "./TheContent.vue?vue&type=script&lang=js&"
import style0 from "./TheContent.vue?vue&type=style&index=0&id=15bac40c&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ichigei/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15bac40c')) {
      api.createRecord('15bac40c', component.options)
    } else {
      api.reload('15bac40c', component.options)
    }
    module.hot.accept("./TheContent.vue?vue&type=template&id=15bac40c&", function () {
      api.rerender('15bac40c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/layouts/Admin/TheContent.vue"
export default component.exports